// extracted by mini-css-extract-plugin
export default {"errorPage":"ErrorPage_errorPage__4+I4R","errorContainer":"ErrorPage_errorContainer__FlsFf","warningIcon":"ErrorPage_warningIcon__RK-8W","appVersion":"ErrorPage_appVersion__R79qU"};